
function Trash({ size = 16, color = "#000" }) {
	return (
		<svg height={size} width={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
			<g fill={color} stroke={color} strokeMiterlimit="10" strokeWidth="1">
				<path
					d="M2.5,6.5v7 c0,1.105,0.895,2,2,2h8c1.105,0,2-0.895,2-2v-7"
					fill="none"
					stroke={color}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<line fill="none" strokeLinecap="round" strokeLinejoin="round" x1="1.5" x2="15.5" y1="3.5" y2="3.5" />
				<line
					fill="none"
					stroke={color}
					strokeLinecap="round"
					strokeLinejoin="round"
					x1="8.5"
					x2="8.5"
					y1="7.5"
					y2="12.5"
				/>
				<line
					fill="none"
					stroke={color}
					strokeLinecap="round"
					strokeLinejoin="round"
					x1="11.5"
					x2="11.5"
					y1="7.5"
					y2="12.5"
				/>
				<line
					fill="none"
					stroke={color}
					strokeLinecap="round"
					strokeLinejoin="round"
					x1="5.5"
					x2="5.5"
					y1="7.5"
					y2="12.5"
				/>
				<polyline
					fill="none"
					points=" 6.5,3.5 6.5,0.5 10.5,0.5 10.5,3.5 "
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</svg>
	);
}

export default Trash;
